import { Button } from './Button';

interface PaginationProps {
  page: number;
  totalPages: number;
  totalElements: number;
  onPageChange: (page: number) => void;
}

/** Zero-based server pagination control. */
export function Pagination({ page, totalPages, totalElements, onPageChange }: PaginationProps) {
  const hasPrev = page > 0;
  const hasNext = page < totalPages - 1;

  return (
    <div className="flex items-center justify-between gap-3 text-sm">
      <p className="text-ink-muted">
        Page {totalPages === 0 ? 0 : page + 1} of {totalPages} · {totalElements} total
      </p>
      <div className="flex gap-2">
        <Button variant="secondary" size="sm" disabled={!hasPrev} onClick={() => onPageChange(page - 1)}>
          Previous
        </Button>
        <Button variant="secondary" size="sm" disabled={!hasNext} onClick={() => onPageChange(page + 1)}>
          Next
        </Button>
      </div>
    </div>
  );
}
